/** @format */

import React, { useEffect } from 'react';
import { InfoBox } from 'components';
import NewDoc from './NewDoc';
import DocsList from './DocsList';
import { getDocumentsService, getDocumentTypes } from './DocumentServices';
import useCustomHook from './hooks';

export default function Docs({ disableDelete }) {
  // --STATES--//
  const {
    loading,
    setLoading,
    loadingDocs,
    setLoadingDocs,
    files,
    setFiles,
    docTypes,
    setDocTypes,
  } = useCustomHook();

  // --HOOKS--//
  useEffect(() => {
    let isMounted = true; // note this flag denote mount status
    if (isMounted) {
      getDocTypes();
      getDocs();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  // --API--//
  const getDocs = async () => {
    try {
      setLoading(true);
      const filesList = await getDocumentsService();
      setFiles(filesList?.result?.list);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getDocTypes = async () => {
    try {
      setLoadingDocs(true);
      const filesList = await getDocumentTypes();
      const types = filesList?.result ?? {};
      const reformedTypes = Object.keys(types).map((v) => ({
        label: types[v],
        value: v,
      }));
      setDocTypes(reformedTypes);
      setLoadingDocs(false);
    } catch (error) {
      setLoadingDocs(false);
    }
  };

  return (
    <>
      <InfoBox
        type="disable"
        content="در این بخش مدارک موردنیاز برای تایید کسب‌وکار خود را بارگذاری نمایید"
      />
      <NewDoc refreshList={getDocs} docTypes={docTypes} loadingDocs={loadingDocs} />
      <DocsList
        docTypes={docTypes}
        disableDelete={disableDelete}
        files={files}
        loading={loading}
        refreshList={getDocs}
      />
    </>
  );
}
